import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-header',
  templateUrl: './custom-header.component.html'
})
export class CustomHeaderComponent {
  @Input() setting: any;
}
